var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.76 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42bdff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "water-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.94,10.12C71.59,42.87,101.76,66.68,101.76,86c0,46.84-68.61,49.07-75.1,6.64a34.53,34.53,0,0,1-5.42-1.12A30.87,30.87,0,0,1,11,86.37C3.92,80.9.68,74.41.1,67.56-.58,59.62,2.39,51.32,7,43.6c1.76-2.94,3.37-5.49,5-8.11,6.34-10,13.49-21.24,16.28-33.31a2.81,2.81,0,0,1,5.47,0c2.81,12,9.95,23.27,16.28,33.25l1.82,2.87C57,29.7,61.58,20.37,63.94,10.12ZM26.19,86.9c0-.3,0-.59,0-.9,0-12.1,11.72-25.82,22.39-42.4-1-1.62-2.12-3.38-3.25-5.17-5.05-7.95-10.59-16.69-14.26-26.18C27.38,21.8,21.82,30.54,16.77,38.5c-1.87,2.93-3.66,5.75-5,8-4,6.79-6.66,14-6.09,20.64.46,5.34,3.05,10.44,8.76,14.84a25.48,25.48,0,0,0,8.36,4.19,27.42,27.42,0,0,0,3.37.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.93,80.48a3.84,3.84,0,0,1,7.64-.69,36.87,36.87,0,0,0,3.72,13.84,24.46,24.46,0,0,0,9.54,9.86A3.83,3.83,0,0,1,58,110.1,31.86,31.86,0,0,1,45.5,97.2a44.59,44.59,0,0,1-4.57-16.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.dd99bb95e1f213eb6c1cca74a57fe94f.svg";
export { ForwardRef as ReactComponent };